import { Checkbox } from "antd";
import { FC } from "react";
import { Point } from "tm-shared/types";

import { PointInfo } from "@/domains/point";

import { StyledPointCardSelectable } from "./Styled";

interface PointCardSelectableProps {
    checked: boolean;
    toggleChecked: () => void;
    point: Point;
}

export const PointCardSelectable: FC<PointCardSelectableProps> = ({
    checked,
    toggleChecked,
    point,
}) => {
    return (
        <StyledPointCardSelectable
            justify="flex-start"
            gap={12}
            align="flex-start"
        >
            <Checkbox
                checked={checked}
                onChange={toggleChecked}
                id={point.id}
            />

            <label htmlFor={point.id}>
                <PointInfo point={point} />
            </label>
        </StyledPointCardSelectable>
    );
};
